import { SVGProps, Ref, forwardRef } from 'react';

export const EnvelopeOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.64 6.505C2.133 7.31 1.8 8.65 1.8 11v2c0 2.9.507 4.261 1.223 4.977S5.1 19.2 8 19.2h8c2.9 0 4.261-.507 4.977-1.223S22.2 15.9 22.2 13v-2c0-2.351-.333-3.69-.84-4.495L12 14.163zm17.287-1.154c-.83-.34-2.059-.551-3.927-.551H8c-1.868 0-3.098.21-3.927.551L12 11.837zM0 11c0-6 2-8 8-8h8c6 0 8 2 8 8v2c0 6-2 8-8 8H8c-6 0-8-2-8-8z"
                fill="currentColor"
            />
        </g>
    </svg>
));
EnvelopeOutlinedSize24Glyph.displayName = 'EnvelopeOutlinedSize24Glyph';
